"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.toEncodedSearchQueryString = exports.searchSeparator = void 0;

var _assign = _interopRequireDefault(require("lodash/assign"));

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

var _decode = _interopRequireWildcard(require("./decode"));

var _renameField = _interopRequireDefault(require("./rename-field"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var encoders = [function encodeHead() {
  return {
    V: '2',
    P: 'jobsearch'
  };
}, (0, _renameField.default)('keywords', 'K'), (0, _renameField.default)('where', 'WH'), (0, _renameField.default)('whereid', 'WID'), (0, _renameField.default)('classification', 'I'), (0, _renameField.default)('subclassification', 'O'), (0, _renameField.default)('sortmode', 'SORT'), function encodeSalaryType(_ref) {
  var salarytype = _ref.salarytype;

  if (!salarytype) {
    return {};
  }

  switch (salarytype) {
    case 'hourly':
      return {
        SFT: 'SalaryHourly',
        SL: 'Hourly'
      };

    case 'monthly':
      return {
        SFT: 'SalaryMonthly',
        SL: 'Monthly'
      };

    default:
      return {
        SFT: 'Salary',
        SL: 'Annual'
      };
  }
}, function encodeSalary(_ref2) {
  var salaryrange = _ref2.salaryrange;

  if (!salaryrange || !/\d*-\d*/.test(salaryrange)) {
    return {};
  }

  var _salaryrange$split = salaryrange.split('-'),
      _salaryrange$split2 = _slicedToArray(_salaryrange$split, 2),
      SF = _salaryrange$split2[0],
      ST = _salaryrange$split2[1];

  return {
    SF: SF || '0',
    ST: ST || '999999'
  };
}, (0, _renameField.default)('daterange', 'D'), (0, _renameField.default)('worktype', 'W'), (0, _renameField.default)('page', 'N'), (0, _renameField.default)('companyid', 'CID'), (0, _renameField.default)('nation', 'NA'), (0, _renameField.default)('location', 'L'), (0, _renameField.default)('area', 'A'), (0, _renameField.default)('advertiserid', 'ADV'), (0, _renameField.default)('advertisergroup', 'ADG'), function encodeGraduateSearch(_ref3) {
  var graduatesearch = _ref3.graduatesearch;
  return graduatesearch === 'true' ? {
    C: '1'
  } : {};
}, function encodeTail(query, date) {
  return {
    OSF: "quick&set=".concat(date.getTime())
  };
}];
var searchSeparator = '/';
exports.searchSeparator = searchSeparator;

var toDecodedSearchQueries = function toDecodedSearchQueries(encodedSearchQueriesStr) {
  return encodedSearchQueriesStr.split(searchSeparator).filter(function (searchQuery) {
    return (0, _decode.default)(searchQuery);
  });
};

var isEqual = function isEqual(decodedOfA, decodedOfB, key) {
  var _decodedOfA$query$key, _decodedOfB$query$key;

  return ((_decodedOfA$query$key = decodedOfA.query[key]) === null || _decodedOfA$query$key === void 0 ? void 0 : _decodedOfA$query$key.toLowerCase()) === ((_decodedOfB$query$key = decodedOfB.query[key]) === null || _decodedOfB$query$key === void 0 ? void 0 : _decodedOfB$query$key.toLowerCase());
};

var filterDuplicateSearchQueries = function filterDuplicateSearchQueries(encodedSearchQueries) {
  return encodedSearchQueries.map(function (encodedSearchQuery) {
    return [(0, _decode.decodeSearch)(encodedSearchQuery), encodedSearchQuery];
  }).reduce(function (uniqueSearchQueries, current) {
    var currentDecoded = current[0];
    var index = uniqueSearchQueries.findIndex(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
          decodedSearchQuery = _ref5[0];

      return isEqual(decodedSearchQuery, currentDecoded, 'keywords') && isEqual(decodedSearchQuery, currentDecoded, 'where') && isEqual(decodedSearchQuery, currentDecoded, 'classification');
    });
    return index >= 0 ? uniqueSearchQueries : [].concat(_toConsumableArray(uniqueSearchQueries), [current]);
  }, []).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        _ = _ref7[0],
        encodedSearchQuery = _ref7[1];

    return encodedSearchQuery;
  });
};

var toEncodedSearchQueryString = function toEncodedSearchQueryString(searchQuery, creationDate) {
  var encodedParts = encoders.map(function (encode) {
    return encode(searchQuery, creationDate);
  });

  var cookieObject = _assign.default.apply(void 0, _toConsumableArray(encodedParts));

  var encodedCookieObject = (0, _mapValues.default)(cookieObject, function (value, key) {
    return key === 'OSF' ? value : encodeURIComponent(value);
  });
  return Object.keys(encodedCookieObject).map(function (key) {
    return "".concat(key).concat(encodeURIComponent('|')).concat(encodedCookieObject[key].split('~')[0]);
  }).join('~');
};
/**
 *
 * @param {*} date Creation date for the new search query input
 * @param {*} query New search query to be prepended to the encoded output
 * @param {*} searchQueriesStr The existing cookie value. NOTE: this value can contain unencoded characters.
 * @returns
 */


exports.toEncodedSearchQueryString = toEncodedSearchQueryString;

function _default(date, query) {
  var searchQueriesStr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var encodedSearchQueriesStr = searchQueriesStr.replace(new RegExp(/\|/, 'g'), '%7C').replace(new RegExp(/\s/, 'g'), '%20');
  var newSearchQueryEncodedStr = toEncodedSearchQueryString(query, date);
  var existingSearchQueries = toDecodedSearchQueries(encodedSearchQueriesStr);
  var searchQueriesWithNewSearch = [newSearchQueryEncodedStr].concat(_toConsumableArray(existingSearchQueries)).filter(Boolean);
  return filterDuplicateSearchQueries(searchQueriesWithNewSearch).slice(0, 3).join(searchSeparator);
}